<script>
import '@/scss/main.scss'
import './styles.scss'
import { mapState, mapGetters } from 'vuex'
import HeaderCentral from '@/components(new)/layout/Headers/HeaderCentral/HeaderCentral.vue'
import ProfileButton from '@/components(new)/UI/Buttons/ProfileButton/ProfileButton.vue'
import SideMenu from '@/components(new)/layout/SideMenu/SideMenu.vue'
import Nav from './Nav/Nav.vue'

export default {
  name: 'LayoutBase',
  components: {
    HeaderCentral,
    ProfileButton,
    SideMenu,
    Nav
  },
  props: {
    menuOptions: {
      required: true,
      default: null
    }
  },
  computed: {
    ...mapState({
      LOGO: state => state.userInterface.dadosEstado.LOGO
    }),
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    getNomeUsuario () {
      if (!this.usuario) return
      return this.usuario.pessoa.nomeRazaoSocial
    },
    getPerfil () {
      if (!this.usuario) return
      return this.usuario.perfilSelecionado ? this.usuario.perfilSelecionado.nome : null
    },
    hasNotificacao () {
      return this.usuario && this.notificacao
    },
    caixaAtual () {
      return this.menuOptions.find(item => item.routeGroup === this.$route.meta.routeGroup)
    },
    caixaAnterior () {
      return this.menuOptions.find(item => item.routeGroup === this.$route.meta?.previousRoute?.meta?.routeGroup)
    },
    rotasNav () {
      const caixa = this.caixaAtual || this.caixaAnterior

      if (!caixa) {
        return []
      }

      const rotas = [{name: caixa.routeGroup, label: caixa.nome}]
      if (this.$route.meta.routeGroup !== caixa.routeGroup) {
        rotas.push({name: this.$route.meta.routeGroup, label: this.$route.meta.title})
      }
      return rotas
    },
    caixaIsActiveOnPreviousRoute () {
      return (!this.caixaAtual && !!this.caixaAnterior)
    }
  },
  methods: {
    irParaSelecaoModulos () {
      this.$router.push({ name: 'selecionarModulo' })
    },
    async sair () {
      this.$router.push({ name: 'logout' })
    }
  }
}
</script>

<template>
  <div class="layout-base">
    <HeaderCentral
      :imageLogoSrc="require('@/assets/images/logo.png')"
      descricaoLogo="Sistema de Cadastro e Regularização Fundiária"
    >
      <template #RightButtons>
        <ProfileButton
          :nameUser="getNomeUsuario"
          :namePerfil="getPerfil"
          :emailUser="`${usuario.pessoa.email}`"
          :opcoesProfileButton="[
            { text: 'Módulos', action: () => irParaSelecaoModulos() },
          ]"
          :ButtonSair="{ text: 'Sair', action: () => sair() }"
        />
      </template>
    </HeaderCentral>
    <div class="main-container">
      <SideMenu
        :items="menuOptions"
        :isActiveOnPreviousRoute="caixaIsActiveOnPreviousRoute"
      />
      <div class="router-view-container" :key="$route.fullPath">
        <Nav
          v-if="rotasNav"
          :routes="rotasNav"
          @goHome="irParaSelecaoModulos"
        />
        <router-view />
        <slot></slot>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/layout/LayoutBases/LayoutAnalise/LayoutAnalise.vue